import { AxiosResponse } from 'axios';
import { SET_KABBALAH_DESIGN_N, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CLEAR_KABBALAH_DESIGN_N_ISLOADING,
  GET_KABBALAH_DESIGN_N,
  SAVE_KABBALAH_DESIGN_N,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import KabbalahDesign_N from '@/services/kabbalah_design_N';
import { Module } from 'vuex';
import {
  GetKabbalahDesign_N,
  SaveKabbalahDesign_N,
} from '@/dtos/kabbalah_design_N.dto';

const kabbalah_design_N: Module<any, {}> = {
  state: {
    // One org-wide row. `data` stays null until the org has saved a design at
    // least once, which is the signal the editor uses to fall back to its
    // built-in template defaults.
    kabbalahDesign_N: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    kabbalahDesign_N: (state: { kabbalahDesign_N: any }) => state.kabbalahDesign_N,
  },
  mutations: {
    [SET_KABBALAH_DESIGN_N]: (
      state: { kabbalahDesign_N: StateObject },
      payload: { data: any; isLoading: any; clearData?: boolean }
    ) => {
      // The other modules only ever write a non-null `data`, which leaves no way
      // to represent "this organization has no design row". `clearData` is that
      // way — a plain null payload still means "leave what is there".
      if (payload.clearData) {
        state.kabbalahDesign_N.data = null;
      } else if (payload.data != null) {
        state.kabbalahDesign_N.data = payload.data;
      }
      state.kabbalahDesign_N.isLoading = payload.isLoading;
    },
  },
  actions: {
    [GET_KABBALAH_DESIGN_N]: async ({ commit }: any, payload: any) => {
      commit(SET_KABBALAH_DESIGN_N, { data: null, isLoading: true });

      const result: AxiosResponse = await KabbalahDesign_N.getKabbalahDesign_N(
        payload as GetKabbalahDesign_N
      );

      if (result) {
        if (result.data.status) {
          commit(SET_KABBALAH_DESIGN_N, {
            data: result.data.data,
            // A first visit answers with a null design; that is the answer, not
            // a missing one, so the previous org's row is cleared out.
            clearData: result.data.data == null,
            isLoading: false,
          });
          return true;
        }
        commit(SET_KABBALAH_DESIGN_N, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      }
      commit(SET_KABBALAH_DESIGN_N, { isLoading: false });
      return false;
    },
    [SAVE_KABBALAH_DESIGN_N]: async ({ commit }: any, payload: any) => {
      commit(SET_KABBALAH_DESIGN_N, { data: null, isLoading: true });

      const result: AxiosResponse = await KabbalahDesign_N.saveKabbalahDesign_N(
        payload as SaveKabbalahDesign_N
      );

      if (result) {
        if (result.data.status) {
          commit(SET_KABBALAH_DESIGN_N, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_KABBALAH_DESIGN_N, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      }
      commit(SET_KABBALAH_DESIGN_N, { isLoading: false });
      return false;
    },
    [CLEAR_KABBALAH_DESIGN_N_ISLOADING]: ({ commit }) => {
      commit(SET_KABBALAH_DESIGN_N, { isLoading: false });
    },
  },
};

export default kabbalah_design_N;
